import {
  channelPartnerList,
  states,
  cities,
  channelPartnerDashboard,
  channelPartnerEnrolledCourseList,
  paymentApprovalRequestList,
} from "constants/channelPartner";

const initialState = {
  channelPartnerList: {},
  states: {},
  cities: {},
  channelPartnerDashboard: {},
  channelPartnerEnrolledCourseList: {},
  paymentApprovalRequestList: {},
};

const channelPartner = (state = initialState, action) => {
  switch (action.type) {
    case channelPartnerList:
      return { ...state, channelPartnerList: action.payload };

    case channelPartnerDashboard:
      return { ...state, channelPartnerDashboard: action.payload };

    case channelPartnerEnrolledCourseList:
      return { ...state, channelPartnerEnrolledCourseList: action.payload };

    case states:
      return { ...state, states: action.payload };

    case cities:
      return { ...state, cities: action.payload };
    case paymentApprovalRequestList:
      return {
        ...state,
        paymentApprovalRequestList: action.payload,
      };
    default:
      return state;
  }
};

export default channelPartner;
